var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{attrs:{"colspan":_vm.colspan}},[_vm._v("\n    Total: "+_vm._s(_vm.money(_vm.total))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }